import { ProjectRole } from '../models/project';

export const normalizeProjectRole = (role?: string | null): ProjectRole => {
  switch ((role ?? '').toLowerCase()) {
    case 'owner':
      return 'Owner';
    case 'useradmin':
      return 'UserAdmin';
    case 'reader':
    case 'member':
      return 'Reader';
  }

  return 'Owner';
};

export const normalizeAssignedUserRole = (role?: string | null): ProjectRole => {
  switch ((role ?? '').toLowerCase()) {
    case 'owner':
      return 'Owner';
    case 'useradmin':
      return 'UserAdmin';
    case 'reader':
    case 'member':
    case 'project_admin':
    case 'project_member':
    case 'project_reader':
      return 'Reader';
  }

  return 'Reader';
};

export const isOwner = (role?: string | null): boolean =>
  normalizeProjectRole(role) === 'Owner';

export const isUserAdmin = (role?: string | null): boolean =>
  normalizeProjectRole(role) === 'UserAdmin';

export const canEditProject = (role?: string | null): boolean =>
  normalizeProjectRole(role) === 'Owner';

export const canManageUsers = (role?: string | null): boolean => {
  const normalizedRole = normalizeProjectRole(role);
  return normalizedRole === 'Owner' || normalizedRole === 'UserAdmin';
};
